import React from 'react';
import Header from '../component/layout/Header';
import Hero from '../component/carriers/Hero';
import Intro from '../component/carriers/Intro';
import App from '../component/carriers/App';
import Features from '../component/carriers/Features';
import Testimonials from '../component/carriers/Testimonials';
import Footer from '../component/layout/Footer';

export default function Carriers() {
  return (
    <div>
      <Header />
      <Hero />
      {/* <Features /> */}
      <Intro />
      <App />
      <Testimonials />
      <Footer />
    </div>
  )
}